// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2v2Nb","range":"MonthRangeSwitch_range__2vduG","disabled":"MonthRangeSwitch_disabled__KxeI-"};